var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A1B46DC2-519B-483E-9DB5-11009A7178A0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M262,282.625 L262,281.75 C262,281.334375 262.334375,281 262.75,281 L266.25,281 L266.54375,280.415625 C266.66875,280.159375 266.928125,280 267.2125,280 L270.784375,280 C271.06875,280 271.328125,280.159375 271.45625,280.415625 L271.75,281 L275.25,281 C275.665625,281 276,281.334375 276,281.75 L276,282.625 C276,282.83125 275.83125,283 275.625,283 L262.375,283 C262.16875,283 262,282.83125 262,282.625 Z M275,284.375 L275,294.5 C275,295.328125 274.328125,296 273.5,296 L264.5,296 C263.671875,296 263,295.328125 263,294.5 L263,284.375 C263,284.16875 263.16875,284 263.375,284 L274.625,284 C274.83125,284 275,284.16875 275,284.375 Z M266.5,286.5 C266.5,286.225 266.275,286 266,286 C265.725,286 265.5,286.225 265.5,286.5 L265.5,293.5 C265.5,293.775 265.725,294 266,294 C266.275,294 266.5,293.775 266.5,293.5 L266.5,286.5 Z M269.5,286.5 C269.5,286.225 269.275,286 269,286 C268.725,286 268.5,286.225 268.5,286.5 L268.5,293.5 C268.5,293.775 268.725,294 269,294 C269.275,294 269.5,293.775 269.5,293.5 L269.5,286.5 Z M272.5,286.5 C272.5,286.225 272.275,286 272,286 C271.725,286 271.5,286.225 271.5,286.5 L271.5,293.5 C271.5,293.775 271.725,294 272,294 C272.275,294 272.5,293.775 272.5,293.5 L272.5,286.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-KIt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-262.000000, -280.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "trash-alt",
    fill: "#8B88FF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashColored);
export default ForwardRef;